"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _constants = require("../../constants/constants");
var _bwaPoweredByAmazon = require("../../apis/bwa/widgets/bwa-powered-by-amazon");
var _bwaInfo = require("../../apis/bwa/widgets/bwa-info");
var _utils = require("../../utils/utils");
var _bwaPoweredByAmazonWatcher = _interopRequireDefault(require("../../events/bwa-powered-by-amazon-watcher"));
var _katalFunnelEvents = require("../../events/katal-funnel-events");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwaPoweredByAmazonRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwaPoweredByAmazonRenderHandler(validateSkuResponse) {
    var _this;
    (0, _classCallCheck2["default"])(this, BwaPoweredByAmazonRenderHandler);
    _this = _callSuper(this, BwaPoweredByAmazonRenderHandler);
    _this.validateSkuResponse = validateSkuResponse;
    _this.variantId = (0, _utils.getVariantId)(window.bwaMerchantConfig.bwaDeliveryBlock.variantIdSelector);
    _this.tInjected = null;
    _this.perceivedLogged = false;
    _this.pre.push(function () {
      _this.config = window.bwaMerchantConfig.bwaPoweredByAmazon;
      _this.poweredByAmazonId = "bwa-powered-by-amazon";
      _this.poweredByAmazonPositionSelector = _this.config && _this.config.poweredByAmazonPositionSelector || "";
      _this.poweredByAmazonCSSClass = "bwa-powered-by-amazon";
      _this.poweredByAmazonContainerId = _constants.BWA_WIDGET_CONTAINER_IDS.BWA_POWERED_BY_AMAZON_CONTAINER_ID;
      _this.infoWidgetId = "bwa-info-widget";
      _this.infoWidgetCSSClass = "bwa-info-widget";
    });
    return _this;
  }
  (0, _inherits2["default"])(BwaPoweredByAmazonRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwaPoweredByAmazonRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.render();
            case 2:
              this.setupEventListeners();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this$validateSkuResp, _this$validateSkuResp2;
        var _skuAvailabilityData$, _this$validateSkuResp3, skuAvailabilityData, inStock, isPoweredByAmazonEnabled;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_SKU, (_this$validateSkuResp = this.validateSkuResponse) === null || _this$validateSkuResp === void 0 ? void 0 : _this$validateSkuResp.isSkuEnabled);
              if ((_this$validateSkuResp2 = this.validateSkuResponse) !== null && _this$validateSkuResp2 !== void 0 && _this$validateSkuResp2.isSkuEnabled) {
                skuAvailabilityData = JSON.parse(sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.SKU_AVAILABILITY_DATA) || '{}');
                inStock = ((_skuAvailabilityData$ = skuAvailabilityData.skuAvailabilityList) === null || _skuAvailabilityData$ === void 0 || (_skuAvailabilityData$ = _skuAvailabilityData$[this.variantId]) === null || _skuAvailabilityData$ === void 0 ? void 0 : _skuAvailabilityData$.inStock) || false;
                isPoweredByAmazonEnabled = (_this$validateSkuResp3 = this.validateSkuResponse) === null || _this$validateSkuResp3 === void 0 ? void 0 : _this$validateSkuResp3.isPoweredByAmazonEnabled;
                if (isPoweredByAmazonEnabled && inStock) {
                  this.injectPoweredByAmazonIframe();
                }
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "injectPoweredByAmazonIframe",
    value: function injectPoweredByAmazonIframe() {
      new _bwaPoweredByAmazonWatcher["default"]();
      var poweredByAmazonIframe = (0, _bwaPoweredByAmazon.poweredByAmazonWidget)(this.poweredByAmazonId, this.poweredByAmazonCSSClass);
      this.tInjected = performance.now();
      this.perceivedLogged = false;
      (0, _utils.insertElementWithFallback)(this.poweredByAmazonContainerId, poweredByAmazonIframe, this.poweredByAmazonPositionSelector);
    }
  }, {
    key: "validateAndRerender",
    value: function validateAndRerender(validateSkuResponseAfterVariantChange) {
      this.validateSkuResponse = validateSkuResponseAfterVariantChange;
      this.clearPoweredByAmazonWidget();
      this.render();
    }
  }, {
    key: "clearPoweredByAmazonWidget",
    value: function clearPoweredByAmazonWidget() {
      var poweredByAmazonWidget = (0, _utils.safeGetElementById)(this.poweredByAmazonId);
      if (poweredByAmazonWidget) {
        poweredByAmazonWidget.remove();
      }
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this2 = this;
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, function (event) {
        var _event$data, _event$data2, _event$data3;
        if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) === _constants.EVENT_TYPE.CUSTOM.BWA_POWERED_BY_AMAZON_INFO_BUTTON_CLICKED) {
          window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.CLICK_POWERED_BY_AMAZON_INFO));
          _this2.injectInfoIframe();
        } else if (((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.type) === _constants.EVENT_TYPE.CUSTOM.BWA_POWERED_BY_AMAZON_INFO_DIALOG_CLOSED) {
          _this2.hideInfoIframe();
        } else if (((_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.type) === _constants.EVENT_TYPE.CUSTOM.BWA_POWERED_BY_AMAZON_RENDERED) {
          if (!_this2.perceivedLogged) {
            _this2.perceivedLogged = true;
            (0, _katalFunnelEvents.logPerceived)("powered_by_amazon", {
              tInjected: _this2.tInjected,
              signalType: "content_visible"
            });
          }
        }
      });
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.VARIANT_UPDATED, /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(event) {
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.validateAndRerender(event.detail.validateSkuResponse);
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "injectInfoIframe",
    value: function injectInfoIframe() {
      var _this3 = this;
      var modalContainer = document.createElement("div");
      modalContainer.id = 'bwa-info-container';
      modalContainer.className = 'bwa-info-widget-modal';
      var iframe = (0, _bwaInfo.infoWidget)(this.infoWidgetId, this.infoWidgetCSSClass);
      modalContainer.appendChild(iframe);

      // Insert at the beginning of body
      document.body.insertBefore(modalContainer, document.body.firstChild);
      modalContainer.classList.add('active');
      modalContainer.addEventListener('click', function (event) {
        if (event.target === modalContainer) {
          _this3.hideInfoIframe();
        }
      });
    }
  }, {
    key: "hideInfoIframe",
    value: function hideInfoIframe() {
      var container = (0, _utils.safeGetElementById)('bwa-info-container');
      if (container) {
        container.remove();
      }
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-powered-by-amazon-render-handler.js.map
